import React from 'react';
import { Link } from 'react-router-dom';

export default function Error401() {
  return (
    <section className='h-screen flex flex-col justify-center items-center'>
      <img src='./images/401Img.png' className='p-3 w-[35%]'></img>
      {/* <h1 className='text-8xl font-extrabold'>401</h1> */}
      {/* <p className='font-semibold text-2xl'>Unauthorized</p> */}
      <Link to="/" className='bg-blue-600 hover:bg-blue-500 p-3 rounded text-white font-bold'>Back Home</Link>
    </section>
  )
}
